import { collection, addDoc, Timestamp, updateDoc, doc } from 'firebase/firestore';
import { db } from '../../config';
import { handleFirebaseError } from '../../error-handling';
import type { SaveExamParams } from './types';
import { withPeriodId } from './examPeriod';

export async function saveClinicalExam(params: SaveExamParams): Promise<string> {
  try {
    console.log('💾 saveClinicalExam called with params:', params);
    const examRef = collection(db, 'clinicalExams');
    // periodId is how canTakeExam / getCurrentPeriodExam find this exam again.
    // Without it the dialog reopens blank and the next save duplicates the doc.
    const dataToSave = {
      ...withPeriodId(params),
      status: params.status || 'completed', // Default to completed if not specified
      date: Timestamp.fromDate(params.date),
      createdAt: Timestamp.now(),
      updatedAt: Timestamp.now()
    };
    console.log('💾 Data being saved to Firestore:', dataToSave);
    const docRef = await addDoc(examRef, dataToSave);

    // Update the user's lastExam field
    const userRef = doc(db, 'users', params.customerId);
    await updateDoc(userRef, {
      lastExam: Timestamp.now()
    });

    return docRef.id;
  } catch (error) {
    handleFirebaseError(error, 'Error saving clinical exam');
    throw error;
  }
}